var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 106,
    viewBox: "0 0 152 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.6102 26.2258L97.5176 41.7062L83.9219 63.3526L77.2045 47.0897L93.6102 26.2258Z",
    fill: "#6957BA",
    stroke: "#6957BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.043 86.5698L107.113 83.8286L83.8437 65.8241L105.412 66.7614L127.043 86.5698Z",
    fill: "#6957BA",
    stroke: "#6957BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.557 13.59L128.615 24.0895L97.2485 26.5487L110.268 13.8432L142.557 13.59Z",
    fill: "#6957BA",
    stroke: "#6957BA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.089 42.1618L135.147 52.6613L103.78 55.1205L116.8 42.415L149.089 42.1618Z",
    fill: "#6957BA",
    stroke: "#6957BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.937 11.8861L83.0533 25.8173L55.6028 36.9L61.6333 21.1135L90.937 11.8861Z",
    fill: "#6957BA",
    stroke: "#6957BA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0615 39.4018L33.0925 54.869L19.6778 76.5905L12.8317 60.3543L29.0615 39.4018Z",
    fill: "#6957BA",
    stroke: "#6957BA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4275 35.6667L52.921 40.3104L73.2957 60.2998L51.8735 57.2713L33.4275 35.6667Z",
    fill: "#6957BA",
    stroke: "#6957BA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7241 85.0049L80.5214 90.6303L49.3911 84.0419L67.7356 76.1509L98.7241 85.0049Z",
    fill: "#6957BA",
    stroke: "#6957BA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9445 65.4008L58.6296 76.3834L27.513 79.8904L39.7878 66.7284L71.9445 65.4008Z",
    fill: "#6957BA",
    stroke: "#6957BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnB);
export default __webpack_public_path__ + "static/media/btn-b.81e562a5d0210f7b51ced687bb811a2c.svg";
export { ForwardRef as ReactComponent };